export default __webpack_public_path__ + "static/media/dontquit.b2ccdc19.png";